import Icon from '@ant-design/icons';

const SunSvg = (props: any) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8 1.5V2.5M8 13.5V14.5M14.5 8H13.5M2.5 8H1.5M12.596 3.404L11.889 4.111M4.111 11.889L3.404 12.596M12.596 12.596L11.889 11.889M4.111 4.111L3.404 3.404M11 8C11 9.6569 9.6569 11 8 11C6.3431 11 5 9.6569 5 8C5 6.3431 6.3431 5 8 5C9.6569 5 11 6.3431 11 8Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SunIcon = (props: any) => <Icon component={SunSvg} {...props} />;
